var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79893 16.0825C6.69415 16.0836 6.59026 16.065 6.49395 16.0279C6.39763 15.9907 6.31102 15.9359 6.23968 15.8668C5.92011 15.5792 5.92011 15.1334 6.23968 14.8457L16.6258 5.51259C16.9454 5.22497 17.4407 5.22497 17.7603 5.51259C18.0799 5.8002 18.0799 6.24601 17.7603 6.53363L7.37417 15.8812C7.21438 16.025 7.00666 16.0969 6.81491 16.0969L6.79893 16.0825Z",
    fill: "#79808A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.56 16.0984H6.84C6.3696 16.0984 6 15.7816 6 15.3784V9.61844C6 9.21524 6.3696 8.89844 6.84 8.89844C7.3104 8.89844 7.68 9.21524 7.68 9.61844V14.6584H13.56C14.0304 14.6584 14.4 14.9752 14.4 15.3784C14.4 15.7816 14.0304 16.0984 13.56 16.0984Z",
    fill: "#79808A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 1.8,
    rx: 0.9,
    transform: "matrix(-1 0 0 1 21.6016 18.5)",
    fill: "#79808A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeIcon);
export default __webpack_public_path__ + "static/media/minimize-icon.8b6035427600a95b834efd37db86e2c6.svg";
export { ForwardRef as ReactComponent };